

export function getId(path, keyField = 'id') {
    return path && path.length ? path.map(row => row[keyField]).join('||') : '';
}

export function getPathIds(path, keyField = 'id') {
    return path && path.length ? path.map(row => row[keyField]) : [];
}